/** @module csi/view/ToolbarFilter */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/toolbar/MultiFilter",
	"./PluginFactory",
	"./ToolbarPlugin"
], function(declare,lang,Action,MultiFilter,PluginFactory,ToolbarPlugin) {

	return PluginFactory.declare("filter", [MultiFilter, ToolbarPlugin], {
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {m_id: "ViewQuery"});
		},

		/**
		 * Associate MultiFilter with view toolbar
		 */
		postCreate: function() {
			this.set("queryMixin", this.getView());
			this.createFilterContainer(this.actionToolbar.domNode);
			this.inherited(arguments);
		},

		/**
		 * Do not instantiate plugin when printing
		 */
		validatePlugin: function(ctx) {
			return !ctx.bPrint;
		},
		
		/**
		 * Invoke filter action - if only one result, then automatically select it
		 * @param {Object} value
		 * @param {Action} action
		 */
		onChange: function(value, action) {
			var	view = this.getView();
			var	fd = view.defView.m_formData;
			if (fd && fd.m_bSelectOne && (value != null)) {
				view.bSelectIfOne = true;
			}

			this.inherited(arguments);
		}
	});
});